import { render, staticRenderFns } from "./MemberLabelIndex.vue?vue&type=template&id=183217c3&scoped=true"
import script from "./MemberLabelIndex.vue?vue&type=script&lang=js"
export * from "./MemberLabelIndex.vue?vue&type=script&lang=js"
import style0 from "./MemberLabelIndex.vue?vue&type=style&index=0&id=183217c3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183217c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183217c3')) {
      api.createRecord('183217c3', component.options)
    } else {
      api.reload('183217c3', component.options)
    }
    module.hot.accept("./MemberLabelIndex.vue?vue&type=template&id=183217c3&scoped=true", function () {
      api.rerender('183217c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/MemberLabelIndex.vue"
export default component.exports